module.exports = __webpack_public_path__ + "media/images/pc/logo-a095d391cee16dfdc1e8feb36b9dd4e5.png";